import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { mountFooter } from './Footer';
import './store/menuStore'; // Import to trigger initialization

// Two independent React roots: header (App) and footer. Order matches DOM (header then footer).
// Both mount immediately; no dependency between them. Menu store runs once and is shared by both.
const root = ReactDOM.createRoot(document.getElementById('portal-header'));
root.render(<App />);
mountFooter();

